import { FEATURE_KEYS, I18N_KEYS, MODULE_KEYS, TELEMETRY_IDS } from '../routes/ids.js';
import { MARKET_PRICE_ROUTE_IDS } from '../routes/market-price-route-ids.js';
const states = {
    loading: { type: 'LOADING', titleKey: I18N_KEYS.COMMON_LOADING, messageKey: I18N_KEYS.COMMON_LOADING },
    empty: { type: 'EMPTY', titleKey: I18N_KEYS.COMMON_EMPTY, messageKey: I18N_KEYS.COMMON_EMPTY },
    error: { type: 'ERROR', titleKey: I18N_KEYS.COMMON_ERROR, messageKey: I18N_KEYS.COMMON_ERROR, retryable: true },
    forbidden: { type: 'FORBIDDEN', titleKey: I18N_KEYS.COMMON_FORBIDDEN, messageKey: I18N_KEYS.COMMON_FORBIDDEN },
    notFound: { type: 'NOT_FOUND', titleKey: I18N_KEYS.COMMON_NOT_FOUND, messageKey: I18N_KEYS.COMMON_NOT_FOUND },
    degraded: { type: 'DEGRADED', titleKey: I18N_KEYS.COMMON_DEGRADED, messageKey: I18N_KEYS.COMMON_DEGRADED },
    stale: { type: 'STALE', titleKey: I18N_KEYS.COMMON_STALE, messageKey: I18N_KEYS.COMMON_STALE },
};
const base = {
    schemaVersion: 1,
    module: MODULE_KEYS.MARKET_DATA,
    feature: FEATURE_KEYS.DATA_MARKET_PRICES,
    telemetryId: TELEMETRY_IDS.HUB_DATA_MARKET,
    accessibilityLabelKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
    privacyClassification: 'CONFIDENTIAL',
    auditPolicy: 'ALWAYS',
    owner: 'market-data',
    availability: 'AVAILABLE',
    titleKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
    layout: 'single',
    states,
    sections: [],
};
export const MARKET_PRICE_MANAGEMENT_PAGES = Object.freeze([
    {
        ...base,
        id: 'page-data-market-price-create',
        routeId: MARKET_PRICE_ROUTE_IDS.CREATE,
    },
    {
        ...base,
        id: 'page-data-market-price-edit',
        routeId: MARKET_PRICE_ROUTE_IDS.EDIT,
    },
]);
